export interface PasswordStrength {
  score: number
  labelKey: string
  color: string
}

export function computePasswordStrength(password: string): PasswordStrength {
  let score = 0
  if (password.length >= 8) score++
  if (/[A-Z]/.test(password)) score++
  if (/[0-9]/.test(password)) score++
  if (/[^A-Za-z0-9]/.test(password)) score++

  const levels: PasswordStrength[] = [
    { score: 0, labelKey: 'enrollment.password.hintDefault', color: '#dcdfe6' },
    { score: 1, labelKey: 'enrollment.password.tooShort', color: '#EA580C' },
    { score: 2, labelKey: 'enrollment.password.weak', color: '#F59E0B' },
    { score: 3, labelKey: 'enrollment.password.medium', color: '#3B82F6' },
    { score: 4, labelKey: 'enrollment.password.strong', color: '#059669' }
  ]

  return levels[score] || levels[0]
}

export function isPasswordValid(password: string): boolean {
  return password.length >= 8 && /[A-Z]/.test(password) && /[0-9]/.test(password)
}
